import { getCurrentDate } from '../../../utilities/dateTime.util'
import { PatientSearchConstants } from '../store/patientSearch.constants'

export const patientSearchSchemas = [
  {
    inputKey: PatientSearchConstants.SET_SSN,
    isNumber: false,
    type: 'object',
    properties: {
      SET_SSN: {
        type: 'string',
        pattern: '^([0-9][0-9][0-9][0-9])$',
      },
    },
    additionalProperties: false,
    required: ['SET_SSN'],
    errorMessage: {
      properties: {
        SET_SSN: 'Must have only 4 digits',
      },
    },
  },
  {
    inputKey: PatientSearchConstants.SET_DOB,
    isNumber: false,
    type: 'object',
    properties: {
      SET_DOB: {
        type: 'string',
        format: 'nemsis-dob',
      },
    },
    additionalProperties: false,
    required: ['SET_DOB'],
    errorMessage: {
      properties: {
        SET_DOB: 'Must be in the format: MM/DD/YYYY and not greater than ' + getCurrentDate(),
      },
    },
  },
]
